import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getSettingEnableNewNAMCommissionModelWebRetailer } from "@faire/retailer-visitor-shared/settings/getSettingEnableNewNAMCommissionModelWebRetailer";
import { LazyBrandAppLandingPage } from "@faire/retailer-visitor-shared/views/brands/app/LazyBrandAppLandingPage";
import { LazyBrandsLandingPage } from "@faire/retailer-visitor-shared/views/brands/landing-page/index";
import { LazyKnownRetailers } from "@faire/retailer-visitor-shared/views/brands/landing-page/LazyKnownRetailer";
import { LazyLandingPage } from "@faire/retailer-visitor-shared/views/brands/landing-page/WithOffer/LazyLandingPage";
import { LazyCategoryLandingPage } from "@faire/retailer-visitor-shared/views/brands/personalized-landing-page/LazyCategoryLandingPage";
import { LazyPersonalizedLandingPage } from "@faire/retailer-visitor-shared/views/brands/personalized-landing-page/LazyPersonalizedLandingPage";
import { LazyBrandsPricingPage } from "@faire/retailer-visitor-shared/views/brands/pricing/LazyBrandsPricingPage";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import { Route } from "@faire/web-api--source/Route";
import { props as brandsRouteProps } from "@faire/web-api--source/routes/brands";
import { props as brandAppLandingPageRouteProps } from "@faire/web-api--source/routes/brands/app";
import { props as personalizedBrandsRouteProps } from "@faire/web-api--source/routes/brands/brandToken";
import { props as brandsCategoryPageProps } from "@faire/web-api--source/routes/brands/category";
import { props as brandsPersonalizedPageProps } from "@faire/web-api--source/routes/brands/personalized";
import { props as brandsPricingProps } from "@faire/web-api--source/routes/brands/pricing";
import { props as brandsReferralOfferPageProps } from "@faire/web-api--source/routes/brands/referral-offer/brandLeadReferralBonusOfferToken";
import { props as brandsReferralProps } from "@faire/web-api--source/routes/brands/referral/brandLeadReferralToken";
import React, { Suspense } from "react";
export var BrandsLandingPageRoutes = function() {
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsxs(Switch, {
            children: [
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, brandAppLandingPageRouteProps), {
                    component: LazyBrandAppLandingPage
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, brandsPersonalizedPageProps), {
                    component: LazyPersonalizedLandingPage
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, brandsCategoryPageProps), {
                    component: LazyCategoryLandingPage
                })),
                getSettingEnableNewNAMCommissionModelWebRetailer() ? /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, brandsPricingProps), {
                    component: LazyBrandsPricingPage
                })) : null,
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, brandsReferralOfferPageProps), {
                    component: LazyLandingPage
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, brandsReferralProps), {
                    component: LazyKnownRetailers
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, personalizedBrandsRouteProps), {
                    component: LazyBrandsLandingPage
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, brandsRouteProps), {
                    component: LazyBrandsLandingPage
                }))
            ]
        })
    });
};
